"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SETTINGS = void 0;
var SETTINGS = {
  CUSTOMER_CATEGORY: {
    BUTTON__CATEGORY: 'outletSalesSettings-button-category',
    CREATE_CATEGORY_MODAL: {
      INPUT__NAME: 'createCategoryModal-input-name',
      BUTTON__CANCEL: 'createCategoryModal-button-cancel',
      BUTTON__SAVE: 'createCategoryModal-button-save'
    },
    DELETE_CATEGORY_MODAL: {
      BUTTON__CANCEL: 'deleteCategoryModal-button-cancel',
      BUTTON__REMOVE: 'deleteCategoryModal-button-remove'
    }
  }
};
exports.SETTINGS = SETTINGS;